<template>
    <div class="universities">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="">Üniversite Ara</label>
                    <div class="input-group">
                        <input class="form-control custom-input" type="text" placeholder="Üniversite Adı" v-model="search">
                        <span class="input-group-btn">
                            <a class="btn btn-primary" style="height: 45px;" @click="searchFilter">
                                <i class="fa fa-search" style="vertical-align: -webkit-baseline-middle;"></i> 
                            </a>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="">İl Seçin</label>
                    <select class="form-control custom-input" v-model="city_id" @change="cityFilter">
                        <option value="" selected hidden disabled>Seçiniz...</option>
                        <option v-for="city in cities" :key="city.id" :value="city.id">{{ city.name }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"> </i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Üniveriste Adı</th>
                                        <th>Şehir</th>
                                        <th>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in items" :key="item.id">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.city.name }}</td>
                                        <td>
                                            <router-link :to="{ name: 'universities.update', params: {id: item.id} }" class="btn btn-primary btn-xs"> <span>Düzenle</span></router-link> / <button class="btn btn-danger btn-xs">  Sil</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="10" @paginate="fetchPosts()"></pagination> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data () {
            return {
                icon: 'fa fa-university',
                tableName: 'Üniversiteler Tablosu',
                tableDesc: 'Bu tablo sitenizde aktif/pasif olan Üniversiteleri gösterir',
                api: 'universities',
                items: [],
                search: '',
                city_id: '',
                cities: [],
            }
        },
        mounted () {
            this.getData()
        },
        methods: {
            getData() {
                this.axios.get(this.api)
                    .then(response => {
                        this.items = response.data.universities
                        this.cities = response.data.cities
                    })
            },
            cityFilter() {
                this.axios.get(this.api, { params: {
                    city : this.city_id,
                }}).then(response => {
                    this.items = response.data.universities
                })
            },
            searchFilter() {
                this.axios.get(this.api, {params: {
                    name: this.search
                }}).then(response => {
                    this.items = response.data.universities
                })
            }
        },
    }
</script>

<style scoped>

</style>